import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization, WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo.png'
import play_hd from './img/play_hd.png'

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'axs';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "USUARIO NAO ENCONTRADO.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-axs-container" ref={nodeRef}>
        <img src={logo} alt="logo" className="logo-axs rounded mx-auto d-block" />
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true} className="axs-form-container">
            <Row className="axs-form-header">
              <img src={play_hd} alt="logo" className="logo-axs-play rounded mx-auto d-block" />
              <h3>Por favor ingresa a tu cuenta de Play de AXS</h3>
            </Row>
            <Row className="axs-form-body">
              <Col sm="12" xs="12" md="12" className="axs-input">
                <Input
                  className="user-input-axs"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                  placeHolder="Correo electrónico"
                />
              </Col>
              <Col sm="12" xs="12" md="12" className="axs-input">
                <Input
                  className="pass-input-axs"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeHolder="Contraseña"
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
            </Row>
            {!onLogin ? (
              <button
                block={!parameters.failureRedirect}
                tabIndex={1}
                type="submit"
                id="submmit"
                className="enter-axs"
                disabled={!props.turnstileSuccess}
              >
                {translate("ButtonEnter")}
              </button>
            ) : (
              <Progress animated color="danger" value={100} />
            )}
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
            <Col sm="12" xs="12" md="12">
              <p className="axs-recovery-pass-link">
                <a href="http://zeus.axsbolivia.com:8011/send-link.xhtml" target="_blank" rel="noopener noreferrer"> ¿Recuperar Contraseña?</a>
              </p>
            </Col>
            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
          </Container>
        </Form>
        <div className="axs-copyright" style={{ textAlign: 'center' }}>
          <p>© AXS Bolivia SA</p>
          <p>Derechos Reservados</p>
        </div>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
